import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  list: {
    flex: "auto",
    overflow: "auto"
  },
  scrollable: {
    height: "100%"
  }
});
